import { ImageLoaderProps } from 'next/image';

export const customImageLoader = ({ src, width }: ImageLoaderProps) => `${src}?w=${width}`;
